<template>
    <div>
        <SoliForm
            :title="`Assign to ${getRoom.title}`"
            text="Add to Room"
            icon="save"
            ref="form"
            :hideBtn="!!availConflict"
            :saveChanges="saveChanges"
            :textSubtitle="
                form.avail
                    ? form.avail.recurrence
                        ? `${globalMomentDate(form.avail.starts_at)} ${
                              form.avail.recurrence.ends_at
                                  ? `until ${globalMomentDate(
                                        form.avail.recurrence.ends_at
                                    )}`
                                  : `· Weekly on ${globalMomentWeekDay(
                                        form.avail.starts_at
                                    )}s`
                          }`
                        : null
                    : null
            "
            @submit="submit"
            @reset="reset"
        >
            <template #body>
                <v-select
                    v-model="form.avail"
                    :items="
                        assignToday
                            .map((avail) => {
                                return {
                                    id: avail.id,
                                    teacher: avail.teacher,
                                    user_id: avail.teacher.id,
                                    recurrence: avail.recurrence,
                                    removed_from_series:
                                        avail.removed_from_series,
                                    starts_at: avail.starts_at,
                                    online_only: avail.online_only,
                                    ends_at: avail.ends_at,
                                    name: `${avail.teacher.name}: 
                                    ${globalMomentTime(
                                        avail.starts_at
                                    )} to ${globalMomentTime(avail.ends_at)}`,
                                };
                            })
                            .filter((e) =>
                                getRoom.extendedProps.user_id
                                    ? e.user_id ==
                                          getRoom.extendedProps.user_id &&
                                      e.online_only
                                    : !e.online_only
                            )
                    "
                    item-text="name"
                    item-value="id"
                    :label="label"
                    hide-details
                    return-object
                    outlined
                    dense
                    :disabled="disabled"
                    :rules="[(v) => !!v || 'Item is required']"
                    @input="checkConflicts"
                ></v-select>
                <SoliChoice
                    v-if="availConflict"
                    @reset="availConflict = null"
                    title="Hey!"
                    :subtitle="`This availability ends on ${globalMomentDate(
                        availConflict
                    )}. Would you like to assign ${
                        form.avail.teacher.first_name
                    } until then?`"
                    button1="Ok"
                    @option1="[(form.recurrence_end = availConflict)]"
                >
                </SoliChoice>
                <SoliChoice
                    v-if="availabilityRemovedFromSeries"
                    @reset="
                        [
                            (availabilityRemovedFromSeries = null),
                            form.confirmedRemovedFromSeries
                                ? null
                                : (form.avail = null),
                        ]
                    "
                    title="Heads up!"
                    :subtitle="`This availability was removed from its recurring series. This assignment will only be scheduled for ${globalMomentDate(
                        form?.avail?.starts_at
                    )}. Do you want to continue?`"
                    button1="Ok"
                    button2="Nevermind"
                    @option1="form.confirmedRemovedFromSeries = true"
                    @option2="form.avail = null"
                    persistent
                >
                </SoliChoice>
                <SoliChoice
                    v-if="futureConflict"
                    title="Uh oh"
                    :subtitle="`${
                        futureConflict.roomConflict
                            ? futureConflict.roomConflict
                            : form.avail.teacher.first_name
                    } is already assigned at this time, starting ${globalMomentDate(
                        //conflicts[0].starts_at
                        new Date(
                            futureConflict.date ??
                                JSON.parse(futureConflict[0])?.starts_at
                        )
                    )}. Would you like to schedule ${
                        form.avail.teacher.first_name
                    } until then?`"
                    button1="Ok"
                    button2="Nevermind"
                    @option1="
                        (form.recurrence_end = futureConflict.date),
                            (futureConflict = null),
                            (form.noConflict = true),
                            ($refs.form.loading = true),
                            submit()
                    "
                    @option2="
                        [
                            (form.noConflict = false),
                            ($refs.form.loading = false),
                        ]
                    "
                    persistent
                    @reset="futureConflict = null"
                >
                </SoliChoice>
                <div class="px-3" v-if="roomConflicts /*|| teacherConflicts*/">
                    <!--<div v-if="teacherConflicts" class="mb-2">
            <small class="red--text">
              {{
                `· ${getTeacher} is already assigned to ${
                  teacherConflicts.room.title
                } beginning on ${globalMomentDate(
                  teacherConflicts.date
                )}. Would you like to schedule ${getTeacher} until then?`
              }}
            </small>
          </div>-->
                    <div
                        v-if="roomConflicts && openRoomTimes.length"
                        class="mb-2"
                    >
                        <small class="red--text">
                            {{
                                `· ${roomConflicts.room.title} has conflicts. Please select an open time within ${getTeacher}'s availability.`
                            }}
                        </small>
                    </div>
                    <div v-if="roomUnavailable" class="mb-2">
                        <small class="red--text">
                            {{
                                `· ${roomConflicts.room.title} is not available during ${getTeacher}'s availability.`
                            }}
                        </small>
                    </div>
                </div>
                <v-btn-toggle
                    v-model="selectedOpening"
                    dense
                    v-if="openRoomTimes.length"
                    style="width: 100%"
                    class="mb-2"
                >
                    <v-row class="pa-6">
                        <v-btn
                            v-for="time in openRoomTimes"
                            :key="time.start"
                            dense
                            block
                            outlined
                            :value="time"
                            class="soli-blue-text rounded-pill my-2"
                            >{{ `${time.start} to ${time.end}` }}</v-btn
                        ><!--<v-btn
                    v-if="more"
                    outlined
                    class="soli-blue-text rounded-pill"
                    style="margin: 12px"
                    :value="null"
                    @click="buttons = false"
                    >Show Unavailable</v-btn
                >-->
                    </v-row>
                </v-btn-toggle>
            </template>
        </SoliForm>
    </div>
</template>

<script>
import { path, isEmpty } from "ramda";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    name: "AssignRoom",
    mixins: [globalMoment],
    props: [
        "availToday",
        "label",
        "disabled",
        "getRoom",
        "roomName",
        "searchDate",
        "assignments",
        "assignToday",
        "errors",
    ],
    data() {
        return {
            form: {
                avail: null,
                noConflict: false,
                recurrence_end: null,
            },
            availConflict: null,
            //teacherConflicts: null,
            futureConflict: null,
            roomConflicts: null,
            openRoomTimes: [],
            selectedOpening: null,
            availabilityRemovedFromSeries: false,
        };
    },
    mounted() {},
    methods: {
        giveUtc(time) {
            var t = moment().format("YYYY-MM-DD");
            var t1 = t + " " + time;
            return moment(t1, "YYYY-MM-DD HH:mm").format();
        },
        checkConflicts(select) {
            if (!select) return;
            //console.log(select);
            if (select.removed_from_series) {
                this.availabilityRemovedFromSeries = true;
                return;
            }

            this.selectedOpening = null;
            this.getOpenTimesInRoom();
            let search = this.form.avail;
            let start = new Date(search.starts_at);
            let end = new Date(search.ends_at);
            let day = start.getDay();
            let allChecks = (e) => {
                return (
                    // start overlap
                    (this.globalMoment24Time(e.starts_at) <=
                        this.globalMoment24Time(start) &&
                        this.globalMoment24Time(e.ends_at) >
                            this.globalMoment24Time(start)) ||
                    // end overlap
                    (this.globalMoment24Time(e.starts_at) <
                        this.globalMoment24Time(end) &&
                        this.globalMoment24Time(e.ends_at) >=
                            this.globalMoment24Time(end)) ||
                    // between
                    (this.globalMoment24Time(e.starts_at) >
                        this.globalMoment24Time(start) &&
                        this.globalMoment24Time(e.ends_at) <
                            this.globalMoment24Time(end))
                );
            };

            this.availConflict = path(
                ["recurrence", "ends_at"],
                this.form.avail
            );

            let checkAssigns = this.assignments
                .sort((a, b) => a.starts_at.localeCompare(b.starts_at))
                .filter((e) => {
                    return (
                        //moment(new Date(e.starts_at)).isAfter(moment(start)) &&
                        new Date(e.starts_at).toISOString().split("T")[0] >= // does this work in safari?
                            new Date(start).toISOString().split("T")[0] &&
                        new Date(e.starts_at).getDay() == day
                    );
                });

            if (!checkAssigns.length) return;

            let roomConflicts = checkAssigns
                .filter((e) => allChecks(e))
                .filter((i) => i.room.id == this.getRoom.id)
                .filter((e) =>
                    !this.form.avail.recurrence ? !e.cancelled : true
                );

            if (roomConflicts.length) {
                this.roomConflicts = {};
                this.roomConflicts.date = roomConflicts[0].starts_at;
                this.roomConflicts.room = roomConflicts[0].room;
            }
        },
        submit() {
            const date = this.globalMomentDate(new Date(this.searchDate));
            let formData = {
                starts_at: this.selectedOpening
                    ? moment(new Date(date + " " + this.selectedOpening.start))
                          .tz("UTC")
                          .format()
                    : this.form.avail.starts_at,
                ends_at: this.selectedOpening
                    ? moment(new Date(date + " " + this.selectedOpening.end))
                          .tz("UTC")
                          .format()
                    : this.form.avail.ends_at,
                availability_id: this.form.avail.id,
                room_id: this.getRoom.id,
                recurrence_end: this.form.recurrence_end,
                recurrence_id: null,
                user_id: this.form.avail.user_id,
                cancelled: false,
                removed_from_series: false,
                futureEvents: !!this.form.avail.recurrence,
                noConflict: this.form.noConflict,
                rrule_freq: "WEEKLY",
                rrule_int: "1",
            };

            this.$inertia.post(`/assignment`, formData, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.form.dialog = false;
                    this.$emit("success");
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    this.$refs.form.loading = false;
                    this.futureConflict = errors;
                },
            });
        },
        reset() {
            this.$emit("reset");
        },
        getOpenTimesInRoom() {
            this.sortIntervals = [];
            this.availableIntervals = [];
            // *** get assignments matching room and day
            let assigns = this.assignments
                .filter((assignment) => {
                    return (
                        moment(assignment.starts_at).format("MMM Do YY") ==
                            moment(new Date(this.searchDate)).format(
                                "MMM Do YY"
                            ) &&
                        assignment.room.id == this.getRoom.id &&
                        (!this.form.avail.recurrence
                            ? !assignment.cancelled
                            : true)
                    );
                })
                .sort(function (a, b) {
                    return a.starts_at.localeCompare(b.starts_at);
                });

            // Build time ranges based on existing assignments in the room
            if (assigns.length) {
                const timeRange = assigns
                    .map((assignment) => {
                        // If found assignment start or end is outside of the selected availability, use the start and end of the availability
                        // Otherwise, use the start/end of the found assignment
                        // Example: selected avail: 9am - 12pm. Found assignment is 1pm - 10pm. Availability is open.
                        // If found assignment is 10am - 12pm. Remove found assignment from availability.
                        return {
                            start:
                                assignment.starts_at < this.form.avail.starts_at
                                    ? moment(this.form.avail.starts_at).format(
                                          "HH:mm"
                                      )
                                    : moment(assignment.starts_at).format(
                                          "HH:mm"
                                      ),
                            end:
                                assignment.ends_at > this.form.avail.ends_at
                                    ? moment(this.form.avail.ends_at).format(
                                          "HH:mm"
                                      )
                                    : moment(assignment.ends_at).format(
                                          "HH:mm"
                                      ),
                        };
                    })
                    .filter((e) => e.end > e.start);
                // Send time ranges to check for conflicts
                this.openRoomTimes = this.findAvailTimes(
                    timeRange,
                    this.form.avail
                );
            }
        },
        findAvailTimes(timeRange, avail) {
            let availStart = moment(avail.starts_at).format("HH:mm");
            let availEnd = moment(avail.ends_at).format("HH:mm");
            // need loop to create busy object
            timeRange.sort((a, b) => {
                var utcA = this.giveUtc(a.start);
                var utcB = this.giveUtc(b.start);
                if (utcA < utcB) {
                    return -1;
                }
                if (utcA > utcB) {
                    return 1;
                }
                return 0;
            });
            const availableTimeArray = [];

            let endTimeFarthest = moment(this.giveUtc(availStart));
            let startTimeMinimum = moment(this.giveUtc(availEnd));

            timeRange.forEach((element, index) => {
                let currentEndTime = moment(this.giveUtc(element.end));
                const currentStartTime = moment(this.giveUtc(element.start));
                if (currentStartTime.isBefore(startTimeMinimum)) {
                    startTimeMinimum = currentStartTime;
                }
                if (currentEndTime.isAfter(endTimeFarthest)) {
                    endTimeFarthest = currentEndTime;
                }
                if (index === timeRange.length - 1) {
                    if (timeRange.length === 1) {
                        availableTimeArray.push({
                            start: availStart,
                            end: currentStartTime.format("HH:mm"),
                        });
                    }
                    availableTimeArray.push({
                        start: endTimeFarthest.format("HH:mm"),
                        end: availEnd,
                    });
                } else {
                    const nextBusyTime = timeRange[index + 1];
                    const nextStartTime = moment(
                        this.giveUtc(nextBusyTime.start)
                    );
                    if (index === 0) {
                        availableTimeArray.push({
                            start: availStart,
                            end: currentStartTime.format("HH:mm"),
                        });
                    }
                    let endTimeToCompare = currentEndTime.isBefore(
                        endTimeFarthest
                    )
                        ? endTimeFarthest
                        : currentEndTime;
                    if (endTimeToCompare.isBefore(nextStartTime)) {
                        availableTimeArray.push({
                            start: endTimeToCompare.format("HH:mm"),
                            end: nextStartTime.format("HH:mm"),
                        });
                    }
                }
            });
            let finalAvails = availableTimeArray
                .filter((avail) => avail.start !== avail.end)
                .map((e) => {
                    return {
                        start: moment(
                            new Date("2000/01/01" + " " + e.start)
                        ).format("h:mm A"),
                        end: moment(
                            new Date("2000/01/01" + " " + e.end)
                        ).format("h:mm A"),
                    };
                });
            return finalAvails;
        },
    },
    computed: {
        saveChanges() {
            return this.roomUnavailable
                ? false
                : this.openRoomTimes.length > 0
                ? this.selectedOpening
                    ? true
                    : false
                : this.form.avail
                ? true
                : false;
        },
        roomUnavailable() {
            return this.roomConflicts && this.openRoomTimes.length == 0 //&&
                ? //!this.teacherConflicts &&
                  //!this.availConflict
                  true
                : false;
        },
        getTeacher() {
            return this.form.avail.teacher.name
                ? this.form.avail.teacher.name.split(" ")[0]
                : null;
        },
    },
};
</script>
